var map = {
	"./30-days.svg": "406a049661",
	"./actions.svg": "01ec59a0a7",
	"./adventures.svg": "99a3866fe8",
	"./calendar.svg": "5d96dcc413",
	"./collections.svg": "8553df2980",
	"./creators.svg": "35ac19350b",
	"./developers.svg": "57dbe7a356",
	"./friends-games.svg": "5c53d5395a",
	"./genres.svg": "ee8deb417e",
	"./library.svg": "5d1165b6a1",
	"./next-week.svg": "9e366ed832",
	"./platforms.svg": "952c0b1471",
	"./previous-year.svg": "807635bf19",
	"./publishers.svg": "ce875c4a93",
	"./puzzles.svg": "efd7087167",
	"./races.svg": "a616f911f5",
	"./reviews.svg": "461746310e",
	"./rpg.svg": "2e484c5e1f",
	"./shooters.svg": "fadf5a026c",
	"./sports.svg": "185a5f3a61",
	"./stores.svg": "c5c8c85683",
	"./strategies.svg": "6aae80afdb",
	"./tags.svg": "d15e71f0b8",
	"./this-week.svg": "1310870bb8",
	"./this-year.svg": "b458793fec",
	"./top-250.svg": "b77ff56e46",
	"./user.svg": "79e4c8a0db",
	"./wishlist.svg": "6d597ce807"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e2ce3ded37";